var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.videoArray.length > 0
          ? _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "全部", name: "first" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      _vm._l(_vm.videoArray, function(item, index) {
                        return _c(
                          "div",
                          _vm._l(item.var, function(item1, index1) {
                            return _c(
                              "el-col",
                              { key: index1, attrs: { span: 12 } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "grid-content bg-purple" },
                                  [
                                    _c("iframe", {
                                      attrs: {
                                        src:
                                          "https://lf9-cdn-tos.bytecdntp.com/cdn/expire-1-M/byted-player-videos/1.0.0/xgplayer-demo.mp4",
                                        scrolling: "no",
                                        border: "0",
                                        frameborder: "no",
                                        framespacing: "0",
                                        allowfullscreen: "true"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "16px",
                                          color: "rgb(70, 73, 73)",
                                          "text-align": "center",
                                          "font-weight": "bold"
                                        }
                                      },
                                      [_vm._v(_vm._s(item1.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "17px",
                                          float: "right",
                                          bottom: "50px",
                                          color: "rgb(166, 170, 170)"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time"
                                        }),
                                        _vm._v(
                                          _vm._s(item1.time) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.videoArray, function(item, index) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: index,
                      attrs: { label: item.title, name: item.name }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        _vm._l(item.var, function(item1, index1) {
                          return _c(
                            "el-col",
                            { key: index1, attrs: { span: 12 } },
                            [
                              _c(
                                "div",
                                { staticClass: "grid-content bg-purple" },
                                [
                                  _c("el-image", {
                                    staticClass: "item_img",
                                    attrs: {
                                      src:
                                        item1.img == ""
                                          ? require("../../assets/images/videobg.png")
                                          : item1.img
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.videoClick(item1)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "16px",
                                        color: "rgb(70, 73, 73)",
                                        "text-align": "center",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [_vm._v(_vm._s(item1.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "17px",
                                        float: "right",
                                        bottom: "50px",
                                        color: "rgb(166, 170, 170)"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-time" }),
                                      _vm._v(
                                        _vm._s(item1.time) + "\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          : _c(
              "h3",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  "justify-content": "center",
                  "align-items": "center",
                  "padding-top": "20%",
                  color: "black"
                }
              },
              [_vm._v("暂无监控")]
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3267f48a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3267f48a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/CloudVideo.vue
// module id = null
// module chunks = 